import React from 'react';
import PropTypes from 'prop-types';
import {Tooltip} from 'antd';
import {useTranslation} from 'react-i18next';
import {colorsStyles} from '../../utils/styles';
import {StyledMatchedBadgeTag} from './StyledMatchedBadge';

const MatchedBadge = ({tooltipTitle}) => {
  const [t] = useTranslation('main');

  return (
    <Tooltip title={tooltipTitle} styles={{root: {minWidth: 350}}}>
      <StyledMatchedBadgeTag color={colorsStyles.neutral_3}>
        {t('matched')}
      </StyledMatchedBadgeTag>
    </Tooltip>
  );
};

MatchedBadge.propTypes = {
  tooltipTitle: PropTypes.string.isRequired,
};

export default MatchedBadge;
